/**
 * Configuration for Kudoz Backend Endpoints
 * Maps to the kudoz-backend service (default port 8080)
 * 
 * This file lists the available endpoints in the kudoz-backend service
 * related to Wallets, Ledger, Earning, Rewards, and Restaurants.
 */

export const KUDOZ_BACKEND_CONFIG = {
  baseUrl: import.meta.env.VITE_KUDOZ_BACKEND_URL || 'http://localhost:8080',
};

export const KUDOZ_ENDPOINTS = {
  /**
   * User Wallet & Ledger Endpoints
   * - Wallet Balance
   * - Ledger (Transaction History)
   */
  USERS: {
    BASE: '/users',
    /** GET /users/:user_id/kudoz - Get user's current Kudoz balance */
    GET_BALANCE: (userId: string | number) => `/users/${userId}/kudoz`,
    /** GET /users/:user_id/kudoz-transactions - Get user's transaction ledger */
    GET_TRANSACTIONS: (userId: string | number) => `/users/${userId}/kudoz-transactions`,
  },

  /**
   * Kudoz Earning Endpoints
   * - Calculate potential earnings
   * - Preview earning effects
   * - Award Kudoz (Transaction)
   */
  EARN: {
    BASE: '/kudoz-earns',
    /** POST /kudoz-earns/calculate - Calculate earnings for an order */
    CALCULATE: '/kudoz-earns/calculate',
    /** POST /kudoz-earns/preview - Preview earning outcome */
    PREVIEW: '/kudoz-earns/preview',
    /** POST /kudoz-earns/award - Award Kudoz to a user (Updates Wallet/Ledger) */
    AWARD: '/kudoz-earns/award',
  },

  /**
   * Kudoz Reward Endpoints
   * - List available rewards
   * - Redeem rewards (Transaction)
   */
  REWARDS: {
    BASE: '/kudoz-rewards',
    /** GET /kudoz-rewards - List available rewards */
    LIST: '/kudoz-rewards',
    /** POST /kudoz-rewards/preview - Preview reward redemption */
    PREVIEW: '/kudoz-rewards/preview',
    /** POST /kudoz-rewards/:kudoz_reward_id/redeem - Redeem a reward (Updates Wallet/Ledger) */
    REDEEM: (rewardId: string | number) => `/kudoz-rewards/${rewardId}/redeem`,
  },

  /**
   * Restaurant Endpoints
   * - Entities that can issue rewards and participate in the ecosystem
   */
  RESTAURANTS: {
    BASE: '/restaurants',
    /** GET /restaurants - List restaurants */
    LIST: '/restaurants',
    /** GET /restaurants/:restaurant_id - Get restaurant details */
    GET_BY_ID: (restaurantId: string | number) => `/restaurants/${restaurantId}`,
    /** POST /restaurants - Create a new restaurant */
    CREATE: '/restaurants',
    /** PUT /restaurants/:restaurant_id - Update restaurant details */
    UPDATE: (restaurantId: string | number) => `/restaurants/${restaurantId}`,
  },
};
